'use strict'

paginationFooterTemplate = require '../../footer.html.mustache'
paginationFooterPresenter = require '../../common/presenters/footer'
domConfig = require '../../../page/frontend/helpers/dom_config'
{dispatchEvent} = require('../../../page/frontend/helpers/event')

module.exports = class PaginationFooterView
  constructor: ({@el}) ->
    @presentedHash = null
    @addEventListenerOnPagination()

  updatePresentedHash: (dealSearch) ->
    page = dealSearch.page
    {number, totalPages, nextPageSize, totalDealCount, startingIndex, endingIndex} = page

    paginationFooter = Object.assign {}, paginationFooterPresenter.toHash {
      requestURL: window.location.pathname
      query: Groupon.Utils.unparam()
      currentPageNumber: number
      totalPages
      nextPageSize: nextPageSize
      totalDealCount: totalDealCount
      startingIndex: startingIndex
      endingIndex: endingIndex
      limitResults: domConfig.get().enabledFeatures?.limitPaginationResults
    }, undefined, {I18n}

    @presentedHash = {paginationFooter}

    this

  addEventListenerOnPagination: ->
    paginationLinks = @el + ' .pagination a'
    document.querySelectorAll(paginationLinks).forEach (el) =>
      el.removeEventListener('click', this.paginationClickHandler)
      el.addEventListener('click', this.paginationClickHandler)

  render: (opts = {}) ->
    if opts.presentedHash then @presentedHash = opts.presentedHash
    document.querySelector(@el)?.innerHTML = @toHtml()
    @addEventListenerOnPagination()

  toHtml: ->
    paginationFooterTemplate.render @presentedHash

  paginationClickHandler: (event) =>
    event.preventDefault()
    dispatchEvent 'click:paginationLink', document.querySelector(@el),
      bubbles: false,
      cancelable: false,
      detail:
        href: event.currentTarget.href
